module.exports = __webpack_public_path__ + "img/img_family_06.678f4bee.svg";